import { Breakpoint, isMedium, isCompact, isExpanded } from '../types';

export const getFooterHeight = (bp: Breakpoint) => {
    if (isMedium(bp)) {
        return '148px';
    } else if (isCompact(bp)) {
        return '164px';
    } else if (isExpanded(bp)) {
        return '88px';
    } else return '0px';
};
